/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// Mark that JS is available so scroll-reveal styles only apply with JS on.
// Without this class, content renders fully visible (no-JS / SSR friendly).
export const onClientEntry = () => {
  document.documentElement.classList.add("js")
}
